module.exports = "<div *ngIf=\"isPayorModule\" class=\"container\" #less>\r\n  <app-auto-complete-facilities-search\r\n    (selectedFacility)=\"onSelectFacilty4Payor($event)\">\r\n\r\n  </app-auto-complete-facilities-search>\r\n</div>\r\n<ag-grid-angular #agGrid1\r\n             class=\"height-45-vh\"\r\n             [gridOptions]=\"gridFacilitysPayor\"\r\n             (cellDoubleClicked)=\"OnCellDoubleClicked($event)\">\r\n</ag-grid-angular>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/facilities-payor/facilities-payor.component.html
// module id = 2326
// module chunks = 66